export interface Cell {
  existed: boolean;
  isReefer: boolean;
  is45Foot: boolean;
}

export interface Grid {
  rows: number;
  cols: number;
  cells: Cell[];
}

export enum VesselHatchType {
  Hatch = 1,
  Bridge = 2,
  Engine = 3,
  Crane = 4,
  Blank = 5,
  Funnel = 6
}

export interface VesselProfileHatch {
  id: number;
  vesselHatchType: VesselHatchType;
  sequence: number;
  minHoldTiers: number;
  maxHoldTiers: number;
  holdRows: number;
  minDeckTiers: number;
  maxDeckTiers: number;
  deckRows: number;
  hasBayFore: boolean;
  hasBayAfter: boolean;
  hasBay40: boolean;
  bayFore: number;
  bayAfter: number;
  bay40: number;
  onDeckFore: Grid;
  onDeckAfter: Grid;
  onDeck40: Grid;
  holdFore: Grid;
  holdAfter: Grid;
  hold40: Grid;
  vesselProfileHatchCovers:VesselProfileHatchCovers[]
}

export interface VesselProfileHatchCovers{
  coverName: string,
  startCell: number,
  endCell: number
}

export interface VesselProfileData {
  vesselProfileId: number;
  vesselProfileName: string;
  vesselProfileHatches: VesselProfileHatch[];
  manualBayNumbering : boolean;
}

export interface Message {
  messageText: string;
  messageType: number;
}

export interface VesselProfileResponse {
  data: VesselProfileData;
  isSuccessful: boolean;
  tag?: any;
  message: Message[];
}
